import cx from 'classnames';
import React from 'react';
import ListContent from 'sly/hubPage/components/HubDynamicContent/InfoBlock';
import { ContactUsProps } from 'sly/marketingPages/ContactUs.types';

import ContactUsForm from './components/ContactUsForm';
import MarketingPageTitle from '../hubPage/components/HubDynamicContent/MarketingPageTitle';

const ContactUs = ({ infoBlockList, path }: ContactUsProps) => {
  // const {
  //   requestInfo: { result },
  // } = usePrefetch('getContactUsInfo');

  // useEffect(() => {
  //   // Chatbot trigger Configurable from strapi,
  //   if (result?.chatbotAutoload === true) {
  //     triggerChatBot(
  //       // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  //       // @ts-ignore
  //       result?.chatbotAutoloadName || GENERIC_CHAT_BOT_TRIGGER,
  //       result?.chatbotAutoloadTime || 25000
  //     );
  //   }
  // }, [result]);

  return (
    <>
      <div
        className={cx(
          'my-xxl mx-m flex',
          'flex-col items-center justify-center',
          'md:my-xxxl md:mx-l',
          'lg:mx-0 lg:mt-[5.5rem] lg:mb-28 lg:flex-row lg:items-baseline'
        )}
        data-tp-id='gen-Flex-a3e36b07-3f84-4005-b583-c06681e33c5e'
      >
        <MarketingPageTitle title='Send us a message' mb='l' />
        <div
          className='rounded-box p-l md:w-[31.5rem]'
          data-tp-id='gen-Block-43aeb522-8a18-4781-8e9f-a76465cfab84'
        >
          <ContactUsForm showLocation path={path} showJobEnquiry />
        </div>
        <div
          className='hidden lg:block lg:w-[9.5rem]'
          data-tp-id='gen-Block-08195954-f767-4316-87c4-cd5466dc37d6'
        />
      </div>
      <hr data-tp-id='gen-Hr-598b054c-0072-4c68-89ef-34409989c2d8' />
      <ListContent infoBlockList={infoBlockList} />
    </>
  );
};

export default ContactUs;
